export const locales = [
	{
		id: "pl",
		slug: "pl",
		iso: "pl-PL",
		default: true,
		name: {
			pl: "Polski",
			en: "Polish",
		},
		dateTimeFormat: {
			date: "yyyy-MM-dd",
			time: "HH:mm",
			dateTime: "yyyy-MM-dd HH:mm",
		},
	},
	{
		id: "en",
		slug: "en",
		iso: "en-US",
		default: false,
		name: {
			pl: "Angielski",
			en: "English",
		},
		dateTimeFormat: {
			date: "dd/MM/yyyy",
			time: "hh:mm a",
			dateTime: "dd/MM/yyyy hh:mm a",
		},
	},
];
